export const theme = {
  colors: {
    primary: "#c61e1e",
    lightPrimary: "#f5e9e9",
    darkPrimary: "#931515",
    lightGrey: "#ECECE9",
    darkGrey: "#343534",
    sisterSitePrimary: "#1971bd",
    sisterSiteDarkPrimary: "#044D80",
  },
  fontFamily: "'Poppins', sans-serif",
  fontSizes: {
    small: "1em",
    medium: "2em",
    large: "3em",
  },
  breakpoints: {
    xs: "0",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1400px",
    xxl: "1600px",
  },
  categoryColor: "rgb(60, 111, 131)"
};
